import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const EvtShareBtn = styled.div`
  overflow: hidden;
  width: ${mixin.pxToVw('36')};
  height: ${mixin.pxToVw('36')};
  background: #fff;
  border-radius: 6px;
  border: 1px solid rgba(0, 0, 0, 0.08);

  .btn {
    width: 100%;
    height: 100%;
  }

  .evt-btn-share {
    svg {
      width: ${mixin.pxToVw('15')};
      height: ${mixin.pxToVw('15')};
    }
  }

  &.heart {
    svg {
      path {
        stroke: black;
        stroke-width: 1.4px;
      }
    }

    .active svg {
      path {
        stroke: none;
        stroke-width: 0;
      }
    }
  }

  @media ${({ theme }) => theme.media.sm} {
    width: 36px;
    height: 36px;

    .evt-btn-share {
      svg {
        width: 15px;
        height: 15px;
      }
    }
  }

  @media ${({ theme }) => theme.media.xl} {
    width: 38px;
    height: 38px;
    background: rgb(196, 196, 196);
    border: none;
    border-radius: 50%;

    &.heart {
      svg {
        width: 22px;
        height: 22px;

        path {
          stroke: #fff;
          stroke-width: 1px;
        }
      }

      .active {
        > div {
          width: 22px;
          height: 22px;
        }

        svg {
          width: 22px;
          height: 22px;
        }
      }
    }
  }
`;
